// extracted by mini-css-extract-plugin
module.exports = {"container":"_1ifue","mobile":"_2zjOC","large":"_380AW","singe":"_37pAJ","search":"_1oOBF","categoryLink":"_2i0qG","link":"u9EgG"};